"use client";
import Link from "next/link";

// Extract all navigation links from the header for the footer
const footerLinks = {
  Trading: [
    { name: "Standard accounts", href: "/standard-accounts" },
    { name: "Professional accounts", href: "/pro-accounts" },
    { name: "Demo trading account", href: "/demo-account" },
    { name: "Deposits", href: "/deposits" },
    { name: "Withdrawals", href: "/withdrawals" },
    { name: "Client protection", href: "/client-protection" },
    { name: "100% A-Book Order Execution", href: "/order-execution" },
  ],
  Markets: [
    { name: "Forex CFD", href: "/forex" },
    { name: "Metals and Energies CFD", href: "/metals-and-energies" },
    { name: "Stocks CFD", href: "/stocks" },
    { name: "Indices CFD", href: "/indices" },
    { name: "Crypto CFD", href: "/crypto" },
  ],
  Platforms: [
    { name: "cTrader Desktop", href: "/ctrader" },
    { name: "cTrader iPhone/iPad", href: "/ctrader-iphone" },
    { name: "cTrader Android", href: "/ctrader-android" },
    { name: "cTrader Web", href: "/ctrader-web" },
    { name: "cTrader iMac", href: "/ctrader-imac" },
    { name: "cTrader Automate", href: "/ctrader-automate" },
    { name: "cTrader Copy", href: "/ctrader-copy" },
  ],
  Tools: [
    { name: "Loss recovery calculator", href: "/loss-recovery-calculator" },
  ],
  Company: [
    { name: "About us", href: "/about-us" },
    { name: "Why FXnity", href: "/why-choose-fxnity" },
    { name: "Contact us", href: "/contact-us" },
    { name: "How does FXnity make money", href: "/how-fxnity-makes-money" },
    { name: "Blog", href: "/blog" },
    { name: "Help center", href: "/help-center" },
  ],
  Legal: [
    { name: "Privacy Policy", href: "/privacy-policy" },
    { name: "Customer Agreement", href: "/customer-agreement" },
    { name: "KYC and AML Policy", href: "/kyc-and-aml-policy" },
  ],
};

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-black backdrop-blur-lg">
      <div className="container-padding py-12">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-6 lg:gap-12">
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="font-semibold mb-4">{category}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-gray-400 hover:text-white transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="space-y-6 text-sm text-gray-400">
            <p className="leading-relaxed">
              <strong className="text-white">Risk Warning:</strong> Trading Forex and CFDs is risky and may not be suitable for all investors. You can lose all or a substantial portion of your investment. Past performance is no indication of future performance. Please understand all risks involved and proceed with caution.
            </p>
            <p className="leading-relaxed">
              <strong className="text-white">Restricted Countries:</strong> We do not provide our services to residents of the following countries – United States of America, Afghanistan, Belarus, Cuba, Central African Republic, Democratic Republic of the Congo, India, Iran, Iraq, Lebanon, Libya, Mali, Myanmar (Burma), Nicaragua, North Korea (Democratic People's Republic of Korea), Russia, Somalia, South Sudan, Sudan, Syria, Venezuela, Yemen, Zimbabwe or Crimea, Donetsk, and Luhansk regions of Ukraine. By accessing this website, you are affirming that you are not a resident of one of the above listed countries and/or regions. The information on this website is not intended for distribution to any person in any country or jurisdiction where such distribution or use would contravene local laws or regulations.
            </p>
            <p className="leading-relaxed">
              This website is operated by FXnity Limited Liability Company (FXnity Sociedad De Responsabilidad Limitada) with a registered address at 2nd Floor, JRC Consulting Group Office CRS Seguros Building, 600 meters west of Escazú Village, Escazú, San Rafael, San José, Costa Rica. Reg number: 3-102-920598
            </p>
          </div>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-8 pt-8 border-t border-white/10">
            <Link href={"/"} className="text-xl font-bold">
              FXnity Limited Liability Company
            </Link>
            <p className="text-sm text-gray-400">
              © 2025 FXnity Limited Liability Company. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
